import { FC } from "react";
import styled from "styled-components";

interface Props {
  className?: string;
}

const Body: FC<Props> = ({ className, children }) => {
  return <Main className={className}>{children}</Main>;
};

const Main = styled.main`
  margin: 0 auto;
  max-width: 640px;
  overflow-x: hidden;
`;

export default Body;
